import fetchJan from "../services/fetchJan";
import patchData from "../services/patchData";
import postData from "../services/postData";

const createVekoVehicle = async ({ data }: any) => {
  const response = await postData({ data, uri: "brands" });
  return response;
};

const fetchAllVehicles = async ({ params }: any) => {
  const response = await fetchJan({
    uri: `carList?${params}`,
  });
  return response;
};

// const fetchAllVehicles = async ({ country_id }: any) => {
//   const response = await fetchJan({
//     uri: `carList?country_id=${country_id}`,
//   });
//   return response;
// };

const fetchVehicleByMake = async ({
  country_id,
  page,
  per_page,
  maker_id,
}: any) => {
  const response = await fetchJan({
    uri: `carList?country_id=${country_id}&page=${page}&per_page=${per_page}&maker_id=${maker_id}`,
  });
  return response;
};

const fetchVehicleByModel = async ({
  country_id,
  page,
  per_page,
  maker_id,
  model_id,
}: any) => {
  const response = await fetchJan({
    uri: `carList?country_id=${country_id}&page=${page}&per_page=${per_page}&maker_id=${maker_id}&model_id=${model_id}`,
  });
  return response;
};

const fetchVehicleDetails = async ({ country_id, car_id }: any) => {
  const response = await fetchJan({
    uri: `carDetail?country_id=${country_id}&car_id=${car_id}`,
  });
  return response;
};

const updateVehilcleDetails = async ({ id, data }: any) => {
  const response = await patchData({ data, uri: `brands/${id}` });
  return response;
};

export {
  createVekoVehicle,
  fetchAllVehicles,
  fetchVehicleByMake,
  fetchVehicleByModel,
  fetchVehicleDetails,
  updateVehilcleDetails,
};
